(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CommunicationType', CommunicationType);

    CommunicationType.$inject = ['$resource'];

    function CommunicationType ($resource) {
        var resourceUrl =  'api/communication-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
